import React from 'react'
import { Route } from 'react-router-dom'
import { Journal } from '../Journal'
import { Article } from '../Article'
import { News } from '../News'

// 1058528 is kpr's journal alter ego
const isProd = process.env.NODE_ENV === 'production' || window.location.hostname.match(/ridewithgps.com/)
export const JOURNAL_USERID = isProd
  ? 1058528
  : 1
// 1058510 is kpr's news alter ego
export const NEWS_USERID = isProd
  ? 1058510
  : 1

export const routes = [
  <Route key='journalArticl' path='/journal/:slug' component={Article} />,
  <Route key='journal' path='/journal' exact component={Journal} />,
  <Route key='newsArticle' path='/news/:slug' component={Article} />,
  <Route key='news' path='/news' exact component={News} />
]
